import StatusBadge from '../components/StatusBadge'
import EditButton from '../components/buttons/EditButton';
import DeleteButton from '../components/buttons/DeleteButton';
import RecurringTaskForm from '../components/forms/RecurringTaskForm'

export default function RecurringPage(props) {
    const {
      recurringDaysOfWeek,
      setRecurringDaysOfWeek,
      recurringTasks,
      filteredRecurringTasks,
      setEditingRecurringId,
      formatDate,
      operationalToday,
      editIcon,
      deleteIcon,
      editingRecurringId,
      newRecurringTask,
      setNewRecurringTask,
      recurringTaskTime,
      setRecurringTaskTime,
      recurringStatusId,
      setRecurringStatusId,
      recurrenceAnchorType,
      setRecurrenceAnchorType,
      persistenceType,
      setPersistenceType,
      recurrenceType,
      setRecurrenceType,
      recurrenceTypes,
      recurringDayOfMonth,
      setRecurringDayOfMonth,
      recurringMonthOfYear,
      setRecurringMonthOfYear,

      recurringMonthlyRuleType,
      setRecurringMonthlyRuleType,

      recurringMonthlyWeekday,
      setRecurringMonthlyWeekday,

      recurringMonthlyWeekNumbers,
      setRecurringMonthlyWeekNumbers,

      recurringSeasonId,
      setRecurringSeasonId,
      seasons,
      seasonalFrequency,
      setSeasonalFrequency,
      recurrenceStartDate,
      setRecurrenceStartDate,
      recurrenceEndDate,
      setRecurrenceEndDate,
      lastReviewedAt,
      setLastReviewedAt,
      resetRecurringForm,
      recurringFocusFilter,
      setRecurringFocusFilter,
      recurringLocationFilter,
      setRecurringLocationFilter,
      recurringSortBy,
      setRecurringSortBy,
      recurringTasksList,
      getRecurrenceSummary,
      getSeasonName,
      formatLabel,
      recurringIntervalValue,
      setRecurringIntervalValue,
      recurringIntervalUnit,
      setRecurringIntervalUnit,
      recurringNotes,
      setRecurringNotes,
      recurringProjectId,
      setRecurringProjectId,
      recurringPriorityId,
      setRecurringPriorityId,
      recurringContextId,
      setRecurringContextId,
      recurringFocusAreaId,
      setRecurringFocusAreaId,
      recurringLocationId,
      setRecurringLocationId,
      recurringTimeOfDayId,
      setRecurringTimeOfDayId,
      recurringImpactId,
      setRecurringImpactId,
      recurringCapacityId,
      setRecurringCapacityId,
      recurringDayTypeId,
      setRecurringDayTypeId,
      recurringIsActive,
      setRecurringIsActive,
      recurringIsPausable,
      setRecurringIsPausable,
      taskTimes,
      statusLevels,
      projects,
      priorityLevels,
      contexts,
      focusAreas,
      locations,
      timeOfDayLevels,
      impactLevels,
      capacityLevels,
      dayTypeLevels,
      recurringSearch,
      setRecurringSearch,
      addRecurringTask,
      updateRecurringTask,
      startEditRecurring,
      deleteRecurringTask

} = props

{

  return (

    <>

{/*RECURRING TASK PAGE*/}


  <div className="header">
    <div>
      <h2 style={{
        color: editingRecurringId ? '#d97706' : '#174ea6'
      }}>
        {editingRecurringId
          ? `Editing: ${
              filteredRecurringTasks.find(
                item => item.id === editingRecurringId
              )?.name || ''
            }`
          : 'Recurring Tasks'}
      </h2>
      <div className="tagline">Create routines that repeat automatically</div>
    </div>
  </div>

  <hr />

<RecurringTaskForm
  editingRecurringId={editingRecurringId}
  startEditRecurring={startEditRecurring}

  newRecurringTask={newRecurringTask}
  setNewRecurringTask={setNewRecurringTask}

  recurringTaskTime={recurringTaskTime}
  setRecurringTaskTime={setRecurringTaskTime}

  recurringStatusId={recurringStatusId}
  setRecurringStatusId={setRecurringStatusId}

  recurrenceAnchorType={recurrenceAnchorType}
  setRecurrenceAnchorType={setRecurrenceAnchorType}

  persistenceType={persistenceType}
  setPersistenceType={setPersistenceType}

  recurrenceType={recurrenceType}
  setRecurrenceType={setRecurrenceType}
  recurrenceTypes={recurrenceTypes}

  recurringIntervalValue={recurringIntervalValue}
  setRecurringIntervalValue={setRecurringIntervalValue}

  recurringIntervalUnit={recurringIntervalUnit}
  setRecurringIntervalUnit={setRecurringIntervalUnit}

  recurringDaysOfWeek={recurringDaysOfWeek}
  setRecurringDaysOfWeek={setRecurringDaysOfWeek}

  recurringDayOfMonth={recurringDayOfMonth}
  setRecurringDayOfMonth={setRecurringDayOfMonth}

  recurringMonthOfYear={recurringMonthOfYear}
  setRecurringMonthOfYear={setRecurringMonthOfYear}

  recurringMonthlyRuleType={recurringMonthlyRuleType}
  setRecurringMonthlyRuleType={setRecurringMonthlyRuleType}

  recurringMonthlyWeekday={recurringMonthlyWeekday}
  setRecurringMonthlyWeekday={setRecurringMonthlyWeekday}

  recurringMonthlyWeekNumbers={recurringMonthlyWeekNumbers}
  setRecurringMonthlyWeekNumbers={setRecurringMonthlyWeekNumbers}

  recurringSeasonId={recurringSeasonId}
  setRecurringSeasonId={setRecurringSeasonId}

  seasons={seasons}
  seasonalFrequency={seasonalFrequency}
  setSeasonalFrequency={setSeasonalFrequency}

  recurrenceStartDate={recurrenceStartDate}
  setRecurrenceStartDate={setRecurrenceStartDate}

  recurrenceEndDate={recurrenceEndDate}
  setRecurrenceEndDate={setRecurrenceEndDate}

  lastReviewedAt={lastReviewedAt}
  setLastReviewedAt={setLastReviewedAt}

  recurringProjectId={recurringProjectId}
  setRecurringProjectId={setRecurringProjectId}

  recurringPriorityId={recurringPriorityId}
  setRecurringPriorityId={setRecurringPriorityId}

  recurringContextId={recurringContextId}
  setRecurringContextId={setRecurringContextId}

  recurringFocusAreaId={recurringFocusAreaId}
  setRecurringFocusAreaId={setRecurringFocusAreaId}

  recurringLocationId={recurringLocationId}
  setRecurringLocationId={setRecurringLocationId}

  recurringTimeOfDayId={recurringTimeOfDayId}
  setRecurringTimeOfDayId={setRecurringTimeOfDayId}

  recurringImpactId={recurringImpactId}
  setRecurringImpactId={setRecurringImpactId}

  recurringCapacityId={recurringCapacityId}
  setRecurringCapacityId={setRecurringCapacityId}

  recurringDayTypeId={recurringDayTypeId}
  setRecurringDayTypeId={setRecurringDayTypeId}

  recurringIsActive={recurringIsActive}
  setRecurringIsActive={setRecurringIsActive}

  recurringIsPausable={recurringIsPausable}
  setRecurringIsPausable={setRecurringIsPausable}

  recurringNotes={recurringNotes}
  setRecurringNotes={setRecurringNotes}

  taskTimes={taskTimes}
  statusLevels={statusLevels}
  projects={projects}
  priorityLevels={priorityLevels}
  contexts={contexts}
  focusAreas={focusAreas}
  locations={locations}
  timeOfDayLevels={timeOfDayLevels}
  impactLevels={impactLevels}
  capacityLevels={capacityLevels}
  dayTypeLevels={dayTypeLevels}

  addRecurringTask={addRecurringTask}
  updateRecurringTask={updateRecurringTask}
  resetRecurringForm={resetRecurringForm}
/>


  <hr style={{ margin: '24px 0', opacity: 0.7 }} />

{/*Recurring Filters*/}

  <div
  style={{
    marginBottom: '20px',
    display: 'flex',
    gap: '10px',
    flexWrap: 'wrap'
  }}
>

  <input
    type="text"
    placeholder="Search recurring tasks..."
    value={recurringSearch}
    onChange={(e) => setRecurringSearch(e.target.value)}
    style={{
      padding: '8px',
      minWidth: '220px',
      borderRadius: '8px',
      border: '1px solid #ccc'
    }}
  />

  <select
    value={recurringFocusFilter}
    onChange={(e) => setRecurringFocusFilter(e.target.value)}
    style={{
      padding: '8px',
      borderRadius: '8px'
    }}
  >
    <option value="all">All Focus Areas</option>

    {focusAreas
      .slice()
      .sort((a, b) => a.name.localeCompare(b.name))
      .map(area => (
        <option key={area.id} value={area.id}>
          {area.name}
        </option>
      ))}
  </select>

  <select
    value={recurringLocationFilter}
    onChange={(e) => setRecurringLocationFilter(e.target.value)}
    style={{
      padding: '8px',
      borderRadius: '8px'
    }}
  >
    <option value="all">All Locations</option>

    {locations
      .slice()
      .sort((a, b) => a.name.localeCompare(b.name))
      .map(location => (
        <option key={location.id} value={location.id}>
          {location.name}
        </option>
      ))}
  </select>

  <select
    value={recurringSortBy}
    onChange={(e) => setRecurringSortBy(e.target.value)}
    style={{
      padding: '8px',
      borderRadius: '8px'
    }}
  >
    <option value="az">A → Z</option>
    <option value="za">Z → A</option>
    <option value="dailyflow">Daily Flow</option>
    <option value="newest">Newest</option>
    <option value="oldest">Oldest</option>
  </select>

</div>

<hr style={{ margin: '24px 0', opacity: 0.7 }} />

<div style={{ marginBottom: '12px' }}>
  <h3 style={{ margin: 0, color: '#0047AB' }}>
    Your Recurring Templates
  </h3>
  <div className="tagline">
    Review, edit, pause, or clean up your routines
  </div>
</div>

{filteredRecurringTasks.length === 0 ? (
  <div style={{ color: '#666', padding: '12px 0' }}>
    No recurring templates yet.
  </div>
) : (
  filteredRecurringTasks.map(item => (
    <div
      key={item.id}
  style={{
    background: 'white',
    border: '1px solid #dbe3f0',
    borderRadius: '8px',
    padding: '4px 10px',
    marginBottom: '6px',
    boxShadow: '0 1px 2px rgba(0,0,0,0.03)'
  }}
>
    {/* Top Row */}
  <div style={{
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: '6px',
    flexWrap: 'wrap'
  }}>
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      rowGap: '2px',
      lineHeight: '1.1',
      flexWrap: 'wrap'
    }}>
      <span style={{ fontWeight: 700 }}>
        {item.name}
             </span>

      <span className="pill">
        🔁 {item.summary}
      </span>

      {item.isSeasonal && item.season_id && (
        <span className="pill">
          🌸 {getSeasonName(item.season_id)}
        </span>
      )}

      {item.isSeasonal && item.seasonal_frequency && (
        <span className="pill">
          {formatLabel(item.seasonal_frequency)}
        </span>
      )}

      {item.priority?.name && (
        <span className="pill">
          ⭐ {item.priority.name}
        </span>
      )}

      {item.taskTime?.name && (
        <span className="pill">
          🕒 {item.taskTime.name}
        </span>
      )}

      <StatusBadge status={item.status?.name} />

    </div>

      <div style={{
        display: 'flex',
        gap: '6px',
        flexWrap: 'wrap',
        marginTop: '4px'
      }}>

       {item.timeOfDay?.name && (
          <span className="task-badge">
            {item.timeOfDay.name}
          </span>
        )}

        {item.impact?.name && (
          <span className="task-badge">{item.impact.name}</span>
        )}

        {item.capacity?.name && (
          <span className="task-badge">{item.capacity.name}</span>
        )}

        {item.dayType?.name && (
          <span className="task-badge">{item.dayType.name}</span>
        )}

      </div>
    <div style={{
        display: 'flex',
        gap: '8px',
        alignItems: 'center'
      }}>
        <EditButton
            onClick={() => startEditRecurring(item)}
        />
      
      <DeleteButton
        onClick={() => deleteRecurringTask(item.id)}
      />
    </div>
  </div>

  {/* Bottom Row */}
  <div style={{
    marginTop: '-12px',
    display: 'flex',
    gap: '0px',
    rowGap: '0px',
    flexWrap: 'wrap',
    fontSize: '12px',
    lineHeight: '1',
    color: '#555',
    paddingLeft: '30px'
  }}>
    {item.project?.name && <span>📁 {item.project.name}</span>}
    {item.context?.name && <span>{item.context.name}</span>}
    {item.focusArea?.name && <span>{item.focusArea.name}</span>}
    {item.location?.name && <span>📍 {item.location.name}</span>}
    <span style={{ marginLeft: '8px' }}>
      {item.is_pausable ? '⏯ Pausable' : '🔒 Always On'}
    </span>

    {item.notes && (
      <span style={{ fontStyle: 'italic', marginLeft: '10px', color: '#666' }}>
        • 📝 {item.notes}
      </span>
    )}
  </div>
</div>
  ))
)}
</>


  );
}}